// Classes.
import { BaseLocator } from "./../locators/base.locator";
import { StringLocatorComponent } from "./../locators/string.locator-component";
import { DateLocatorComponent } from "./../locators/date.locator-component";
import { CardinalityLocatorComponent } from "./../locators/cardinality.locator-component";
import { ParaArcheryLocatorComponent } from "./paraarchery.locator-component";

export class WorldRankingCategoryListLocator extends BaseLocator {
  public name: StringLocatorComponent;
  public date: DateLocatorComponent;
  public team: CardinalityLocatorComponent;
  public isPara: ParaArcheryLocatorComponent;

  constructor() {
    super("worldRankingCategoryList");
    this.addComponentByType("team");
    this.addComponentByType("date");
    this.addComponentByType("isPara");
  }
}
